<script>
export default {
  name: "reset-password-modal",
  props: {
    visible: Boolean,
  },
  data: function() {
    return {
      email: "",
      emailRules: [(v) => validateEmail(v) || "Invalid Email Address"],
      autofilled: false,
    };
  },
  methods: {
    async resetPassword() {
      this.onModalClose();
      var result = await this.$store.dispatch("getRequest", { controller: "login", method: `Reset`, parameters: { email: this.email } });

      if (result) {
        this.$store.commit("setMessage", { title: "Password Reset", type: "info", content: `Please check your emails for a reset link` });
      }
    },
    onModalShown: function() {
      this.email = "";
    },
    onModalClose: function() {
      this.$emit("closeModal");
    },
  },
  computed: {},
  watch: {
    email() {
      this.autoFilled = true;
    },
  },
};
</script>
<template>
  <v-row justify="center">
    <v-dialog v-model="visible" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline primary--text">Reset Password</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <i>If there is an account associated with the email address provided below, you should receive an email with further instructions.</i>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  hide-details="auto"
                  dense
                  class="login-textfield"
                  background-color="transparent"
                  :placeholder="!autofilled ? ' ' : ''"
                  v-model="email"
                  label="Email Address"
                  :rules="emailRules"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" class="text--primary" @click="onModalClose()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="resetPassword()">
            Send Reset Link
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
